module.exports = __webpack_public_path__ + "img/hongbao_2_100.16fb3625.png";